"use client";

import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AllBtobsales = () => {
  const [sales, setSales] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchSales();
  }, []);

  const fetchSales = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        "https://logicx.premierlam.com/api/get-pixel-btobsales",
        { headers: { authorization: localStorage.getItem("accessToken") } }
      );
      setSales(res.data.data || []);
    } catch {
      toast.error("Failed to fetch B2B sales");
    } finally {
      setIsLoading(false);
    }
  };

  const filteredSales = sales.filter((s) =>
    Object.values(s)
      .join(" ")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  return (
    <>
      <ToastContainer />

      <div className="min-h-screen bg-gray-50 p-2">
        <div className="max-w-7xl mx-auto">

          {/* HEADER */}
          <div className="flex justify-between items-start mb-6">
            <div>
              <h1 className="text-2xl font-semibold text-gray-900">
                B2B Sales
              </h1>
              <p className="text-gray-500">All B2B sales records</p>
            </div>

            <Link
              to="/add-btobsales"
              className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg"
            >
              + Add B2B Sale
            </Link>
          </div>

          {/* TABLE */}
          <div className="bg-white rounded-lg shadow-sm border p-6">
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="mb-4 px-4 py-2 border rounded-lg w-64"
            />

            <div className="overflow-x-auto">
              {isLoading ? (
                <div className="text-center py-6">Loading...</div>
              ) : (
                <table className="w-full text-sm whitespace-nowrap">
                  <thead>
                    <tr className="border-b text-gray-600">
                      <th className="px-3 py-2">Order ID</th>
                      <th className="px-3 py-2">Invoice No</th>
                      <th className="px-3 py-2">Invoice Link</th>
                      <th className="px-3 py-2">Company Name</th>
                      <th className="px-3 py-2">Customer Name</th>
                      <th className="px-3 py-2">Customer Email</th>
                      <th className="px-3 py-2">Customer Phone</th>
                      <th className="px-3 py-2">GSTIN</th>
                      <th className="px-3 py-2">Billing Address</th>
                      <th className="px-3 py-2">Shipping Address</th>
                      <th className="px-3 py-2">Place of Supply</th>
                      <th className="px-3 py-2">Customer State</th>
                      <th className="px-3 py-2">No. of Items</th>
                      <th className="px-3 py-2">AWB Number</th>
                      <th className="px-3 py-2">Courier Partner</th>
                      <th className="px-3 py-2">Tracking Link</th>
                      <th className="px-3 py-2">Invoice Amount</th>
                      <th className="px-3 py-2">Payment Mode</th>
                      <th className="px-3 py-2">Transaction ID</th>
                      <th className="px-3 py-2">Payment Date</th>
                      <th className="px-3 py-2">Advance Amount</th>
                      <th className="px-3 py-2">Pending Amount</th>
                      <th className="px-3 py-2">Total Amount</th>
                      <th className="px-3 py-2">GST Amount</th>
                      <th className="px-3 py-2">Created At</th>
                      <th className="px-3 py-2">Added By</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredSales.map((s) => (
                      <tr key={s.created_at} className="border-b hover:bg-gray-50">
                        <td className="px-3 py-2">{s.order_id}</td>
                        <td className="px-3 py-2">{s.invoice_no}</td>

                        <td className="px-3 py-2">
                          <a
                            href={s.invoice_link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 underline"
                          >
                           {s.tracking_link}
                          </a>
                        </td>

                        <td className="px-3 py-2">{s.company_name}</td>
                        <td className="px-3 py-2">{s.customer_name}</td>
                        <td className="px-3 py-2">{s.customer_email}</td>
                        <td className="px-3 py-2">{s.customer_phone}</td>
                        <td className="px-3 py-2">{s.GSTIN}</td>
                        <td className="px-3 py-2">{s.billing_address}</td>
                        <td className="px-3 py-2">{s.shipping_address}</td>
                        <td className="px-3 py-2">{s.place_of_supply}</td>
                        <td className="px-3 py-2">{s.customer_state}</td>
                        <td className="px-3 py-2">{s.number_of_items}</td>
                        <td className="px-3 py-2">{s.awb_number}</td>
                        <td className="px-3 py-2">{s.courier_partner}</td>

                        <td className="px-3 py-2">
                          <a
                            href={s.tracking_link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 underline"
                          >
                          {s.tracking_link}
                          </a>
                        </td>

                        <td className="px-3 py-2">{s.invoice_amount}</td>
                        <td className="px-3 py-2">{s.payment_mode}</td>
                        <td className="px-3 py-2">{s.transaction_id}</td>
                        <td className="px-3 py-2">{s.payment_date}</td>
                        <td className="px-3 py-2">{s.advance_amount}</td>
                        <td className="px-3 py-2">{s.pending_amount}</td>
                        <td className="px-3 py-2">{s.total_amount}</td>
                        <td className="px-3 py-2">{s.gst_amount}</td>
                        <td className="px-3 py-2">{formatDate(s.created_at)}</td>
                        <td className="px-3 py-2">{s.added_by}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default AllBtobsales;

//   to="/add-btobsales"
// "use client";

// import { useEffect, useState } from "react";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const AllBtobsales = () => {
//   const [sales, setSales] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     fetchSales();
//   }, []);

//   const fetchSales = async () => {
//     try {
//       setIsLoading(true);
//       const res = await axios.get(
//         "https://logicx.premierlam.com/api/get-pixel-btobsales",
//         { headers: { authorization: localStorage.getItem("accessToken") } }
//       );
//       setSales(res.data.data || []);
//     } catch {
//       toast.error("Failed to fetch B2B sales");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const filteredSales = sales.filter((s) =>
//     Object.values(s)
//       .join(" ")
//       .toLowerCase()
//       .includes(searchTerm.toLowerCase())
//   );

//   const formatDate = (date) =>
//     new Date(date).toLocaleDateString("en-GB", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });

//   return (
//     <>
//       <ToastContainer />

//       <div className="min-h-screen bg-gray-50 p-2">
//         <div className="max-w-7xl mx-auto">

//           {/* HEADER */}
//           <div className="flex justify-between items-start mb-6">
//             <div>
//               <h1 className="text-2xl font-semibold text-gray-900">
//                 B2B Sales
//               </h1>
//               <p className="text-gray-500">All B2B sales records</p>
//             </div>

//             <Link
//               to="/add-btobsales"
//               className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg"
//             >
//               + Add B2B Sale
//             </Link>
//           </div>

//           {/* TABLE */}
//           <div className="bg-white rounded-lg shadow-sm border p-6">
//             <input
//               type="text"
//               placeholder="Search..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="mb-4 px-4 py-2 border rounded-lg w-64"
//             />

//             <div className="overflow-x-auto">
//               {isLoading ? (
//                 <div className="text-center py-6">Loading...</div>
//               ) : (
//                 <table className="w-full text-sm whitespace-nowrap">
//                   <thead>
//                     <tr className="border-b text-gray-600">
//                       <th className="px-3 py-2">Order ID</th>
//                       <th className="px-3 py-2">Invoice No</th>
//                       <th className="px-3 py-2">Company</th>
//                       <th className="px-3 py-2">Customer</th>
//                       <th className="px-3 py-2">Phone</th>
//                       <th className="px-3 py-2">Invoice Amount</th>
//                       <th className="px-3 py-2">Payment Date</th>
//                       <th className="px-3 py-2">Invoice</th>
//                       <th className="px-3 py-2">Tracking</th>
//                       <th className="px-3 py-2">Created</th>
//                       <th className="px-3 py-2">Added By</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {filteredSales.map((s) => (
//                       <tr key={s.created_at} className="border-b hover:bg-gray-50">
//                         <td className="px-3 py-2">{s.order_id}</td>
//                         <td className="px-3 py-2">{s.invoice_no}</td>
//                         <td className="px-3 py-2">{s.company_name}</td>
//                         <td className="px-3 py-2">{s.customer_name}</td>
//                         <td className="px-3 py-2">{s.customer_phone}</td>
//                         <td className="px-3 py-2">{s.invoice_amount}</td>
//                         <td className="px-3 py-2">{s.payment_date}</td>

//                         <td className="px-3 py-2">
//                           <a
//                             href={s.invoice_link}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             className="text-blue-600 underline"
//                           >
//                             View
//                           </a>
//                         </td>

//                         <td className="px-3 py-2">
//                           <a
//                             href={s.tracking_link}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             className="text-blue-600 underline"
//                           >
//                             Track
//                           </a>
//                         </td>

//                         <td className="px-3 py-2">
//                           {formatDate(s.created_at)}
//                         </td>
//                         <td className="px-3 py-2">{s.added_by}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               )}
//             </div>
//           </div>

//         </div>
//       </div>
//     </>
//   );
// };

// export default AllBtobsales;
